import { render, staticRenderFns } from "./DesignHeader.vue?vue&type=template&id=6f8ced22&scoped=true&"
import script from "./DesignHeader.vue?vue&type=script&lang=js&"
export * from "./DesignHeader.vue?vue&type=script&lang=js&"
import style0 from "./DesignHeader.vue?vue&type=style&index=0&id=6f8ced22&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8ced22",
  null
  
)

export default component.exports